import { useParams } from 'react-router-dom';
import { useGetMemberships } from '../services/get-memberships';

export const useGetOrgId = () => {
  const { organizationSlug } = useParams();
  const { data: memberships } = useGetMemberships();

  return memberships?.find(
    (membership) => membership.organization.slug === organizationSlug
  )?.organization.id;
};
